module.exports = __webpack_public_path__ + "img/sugardaddy-site-2021.742aca3a.svg";